import { Typography } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { useTranslation } from 'react-i18next'

export const ENTER_ID_PASSWORD_TEXT = 'login.message.normal_login'
export const ENTER_PIN_TEXT = 'login.message.pin_login'

function EnterLoginText({ isLoginWIthEmail = true }) {
    const { t } = useTranslation()
    const { isLandscapeMobile, isMobile } = useScreenSize()
    return (
        <Typography
            sx={{
                color: '#fff',
                textAlign: 'center',
                fontSize: isMobile ? '12' : isLandscapeMobile ? 14 : 20,
            }}
        >
            {isLoginWIthEmail ? t(ENTER_ID_PASSWORD_TEXT) : t(ENTER_PIN_TEXT)}
        </Typography>
    )
}

export default EnterLoginText
